import Splide from '@splidejs/splide';
import '@splidejs/splide/css';

export function commonFunc() {
	handleSamePageAnchorLinks();
	slider01();
	caseSearchToggle();
	caseSearchReset();
}

export function commonLoadFunc() {
	handleCrossPagesAnchorLinks();
}

/**
 * アンカーリンク（同一ページ内）
 */
function handleSamePageAnchorLinks() {
	const header = document.querySelector('.l-header');
	const headerHeight = header ? header.offsetHeight : 0;

	function handleAnchorClick(event) {
		const target = event.target.closest('a[href*="#"]');
		if (target) {
			const href = target.getAttribute('href');
			const anchorIndex = href.indexOf('#');

			if (anchorIndex !== -1) {
				const targetUrlWithoutHash = href.slice(0, anchorIndex);
				const currentUrlWithoutHash = window.location.pathname + window.location.search;

				const isSamePageLink = (targetUrlWithoutHash === '' || targetUrlWithoutHash === currentUrlWithoutHash);

				if (isSamePageLink) {
					event.preventDefault();
					const targetId = href.slice(anchorIndex + 1);
					const targetElement = document.getElementById(targetId);
					if (targetElement) {
						const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY;
						window.scrollTo({
							top: targetPosition - headerHeight,
							behavior: 'smooth'
						});
					}
				}
			}
		}
	}

	document.addEventListener('click', handleAnchorClick);
}

/**
 * アンカーリンク（ページ遷移）
 */
function handleCrossPagesAnchorLinks() {
    if (!window.location.hash) return;

    const header = document.querySelector('.l-header');
    const headerHeight = header ? header.offsetHeight : 0;
    const targetId = window.location.hash.slice(1);
    const targetElement = document.getElementById(targetId);

    if (targetElement) {
        // スクロール位置の計算を修正
        const targetPosition = targetElement.offsetTop - headerHeight;

        // DOMの読み込み完了後に実行するため、少し遅延させる
        setTimeout(() => {
            window.scrollTo({
                top: targetPosition,
                behavior: 'smooth'
            });
        }, 100);
    }
}


/**
 * case Carousel
 */
const slider01 = () => {
	const slider = document.querySelector('.p-slider01');
	if (!slider)  return;

	new Splide('.p-slider01', {
		type       : 'loop',
		perPage    : 3,
		perMove    : 1,
		pagination : true,
		autoHeight: true,
		updateOnMove: true,
		breakpoints: {
			767: {
				perPage: 1,
			},
		},
	}).mount();
};

/**
 * 事例検索窓のアコーディオントグル
 */
const caseSearchToggle = () => {
	const toggleButton = document.querySelector('.js-case-search-toggle');
	const block = document.querySelector('.p-case-search');

	if (!toggleButton || !block) return;

	toggleButton.addEventListener('click', () => {
		block.classList.toggle('is-open');
	});
};

/**
 * 事例検索窓のinputをクリア
 */
const caseSearchReset = () => {
	const resetButton = document.querySelector('.js-search-reset');
	const form = document.querySelector('.search-form');

	if (!resetButton || !form) return;

	resetButton.addEventListener('click', () => {
		// すべてのチェックボックスを外す
		const checkboxes = form.querySelectorAll('input[type="checkbox"]');
		checkboxes.forEach(checkbox => {
			checkbox.checked = false;
		});
	});
};